module.exports = {"username":"Tên đăng nhập","password":"Mật khẩu","logIn":"Đăng nhập","allRightsReserved":"{name} © Đã đăng ký Bản quyền {date}","noMatch":"Tên người dùng và mật khẩu không khớp"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/vi.json
// module id = 816
// module chunks = 0